"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Folder = void 0;
var _ = require("lodash");
var React = require("react");
var OptionsButton_1 = require("../../../Buttons/OptionsButton");
var Highlighted_1 = require("../../../Highlighted");
var Localization_1 = require("../../../Localization");
var Theme_1 = require("../../../Theme");
var DropListItem_1 = require("../../DropList/DropListItem");
var FieldSelector_context_1 = require("../FieldSelector.context");
var Folder_styles_1 = require("./Folder.styles");
var iconSize = "16px";
var buttonSize = "20px";
var Folder = function (_a) {
    var Item = _a.Item;
    var _b = FieldSelector_context_1.useFieldSelector(), CurrentSearchString = _b.CurrentSearchString, rest = __rest(_b, ["CurrentSearchString"]);
    var _c = React.useState(false), optionsMenu = _c[0], setOptionsMenu = _c[1];
    var canDuplicate = function () { return Item.CanDuplicate && rest.OnDuplicate; };
    var canDuplicateByField = function () { return Item.CanDuplicate && rest.OnDuplicateByField; };
    var canDuplicateByCriteria = function () { return Item.CanDuplicate && rest.OnDuplicateByCriteria; };
    var canDelete = function () { return Item.CanDelete && rest.OnRemoveDuplicateTable; };
    var canRename = function () { return Item.CanRename && rest.OnRenameDuplicateTable; };
    var canEditCriteria = function () {
        return rest.CanEditCriteriaFeature && Item.CanEditCriteria && rest.OnDuplicateTableEditCriteria;
    };
    var handleOnDuplicate = function () { return rest.OnDuplicate(_.cloneDeep(Item)); };
    var handleOnDuplicateByField = function () { return rest.OnDuplicateByField(_.cloneDeep(Item)); };
    var handleOnDuplicateByCriteria = function () { return rest.OnDuplicateByCriteria(_.cloneDeep(Item)); };
    var handleOnRenameDuplicateTable = function () { return rest.OnRenameDuplicateTable(_.cloneDeep(Item)); };
    var handleOnDuplicateTableEditCriteria = function () { return rest.OnDuplicateTableEditCriteria(_.cloneDeep(Item)); };
    var handleOnRemoveDuplicateTable = function () { return rest.OnRemoveDuplicateTable(_.cloneDeep(Item)); };
    var renderOptionsMenu = function () {
        if (canDuplicate() ||
            canDelete() ||
            canRename() ||
            canEditCriteria() ||
            canDuplicateByCriteria() ||
            canDuplicateByField()) {
            return (React.createElement(OptionsButton_1.OptionsButton, { Placement: "bottom-end", Title: Localization_1.strings.Label_MoreOptions, AriaLabel: Localization_1.strings.Label_MoreOptions, IconSize: iconSize, ButtonSize: buttonSize },
                canDuplicate() && (React.createElement(DropListItem_1.DropListItem, { OnClick: handleOnDuplicate }, Localization_1.strings.Action_Duplicate)),
                canDuplicateByField() && (React.createElement(DropListItem_1.DropListItem, { OnClick: handleOnDuplicateByField }, Localization_1.strings.Action_DuplicateByField)),
                canDuplicateByCriteria() && (React.createElement(DropListItem_1.DropListItem, { OnClick: handleOnDuplicateByCriteria }, Localization_1.strings.Action_DuplicateByCriteria)),
                canRename() && (React.createElement(DropListItem_1.DropListItem, { OnClick: handleOnRenameDuplicateTable }, Localization_1.strings.Action_Rename)),
                canEditCriteria() && (React.createElement(DropListItem_1.DropListItem, { OnClick: handleOnDuplicateTableEditCriteria }, Localization_1.strings.Action_EditCriteria)),
                canDelete() && (React.createElement(DropListItem_1.DropListItem, { OnClick: handleOnRemoveDuplicateTable }, Localization_1.strings.Action_Delete))));
        }
        return null;
    };
    return (React.createElement(Folder_styles_1.Wrapper, { onMouseEnter: function () { return setOptionsMenu(true); }, onMouseLeave: function () { return setOptionsMenu(false); } },
        React.createElement(Folder_styles_1.CaptionWrapper, { style: optionsMenu ? { color: Theme_1.Color.Blue.B60 } : null },
            React.createElement(Highlighted_1.Highlighted, { Highlight: CurrentSearchString, Text: Item.Caption })),
        React.createElement(Folder_styles_1.Button, null, optionsMenu ? renderOptionsMenu() : null)));
};
exports.Folder = Folder;
